module.exports = __webpack_public_path__ + "img/file-pdf.1df867e0.svg";